import React from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Zoom,
  Box,
} from '@mui/material';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Zoom ref={ref} {...props} timeout={350} />;
});

export default function ConfirmModal(props) {
  const { handleClose, message, title, onSubmitConfirm, open } = props;

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      TransitionComponent={Transition}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      maxWidth="sm"
      fullWidth
    >
      <Box sx={{ p: 2 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
          <WarningAmberIcon sx={{ fontSize: 40, color: 'warning.main', mr: 2 }} />
          <DialogTitle id="alert-dialog-title" sx={{ p: 0, typography: 'h5', fontWeight: 600 }}>
            {title}
          </DialogTitle>
        </Box>
        <DialogContent sx={{ px: 0, pb: 3 }}>
          <DialogContentText id="alert-dialog-description" sx={{ typography: 'body1', color: 'text.primary' }}>
            {message}
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ px: 0, pb: 0, gap: 1 }}>
          <Button onClick={handleClose} variant="outlined" color="secondary" autoFocus>
            Cancel
          </Button>
          <Button onClick={onSubmitConfirm} variant="contained" color="primary">
            Confirm
          </Button>
        </DialogActions>
      </Box>
    </Dialog>
  );
}